import { PageContainer as Page } from 'components'
import styled, { css } from 'styled-components'

export const InsuranceWrapper = styled.div<{ accepted?: boolean }>`
  ${({ accepted = false }) => css`
    border: 1px solid ${accepted ? 'var(--primary500)' : 'var(--gray200)'};
  `}
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  background-color: var(--neutral-theme, #fff);
  display: flex;
  flex-direction: column;
`

export const TagStyled = styled.span`
  display: inline-block;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  color: var(--white);
  background-color: var(--success500);
  width: fit-content;
`

export const HeaderTitle = styled.div`
  margin: 8px 0;

  h3 {
    margin: 0;
  }
`

export const BenefitsList = styled.ul`
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const BenefitItem = styled.li`
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
`

export const BenefitIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
`

export const OptionsGroup = styled.div`
  display: flex;
  flex-direction: column;
`

export const OptionCard = styled.button`
  width: 100%;
  text-align: left;
  background-color: var(--gray100);
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:focus-visible {
    outline: 2px solid var(--primary300);
    outline-offset: 2px;
  }
`

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const OptionPrice = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 4px;
`

export const RadioSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Disclaimer = styled.p`
  margin: 16px 0 0;
  color: var(--gray400);
  font-size: 12px;
  line-height: 14px;

  span,
  a {
    font-size: 12px;
    line-height: 14px;
  }
`

export const DisclaimerLink = styled.a`
  color: var(--primary500);
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`

export const InfoButtonRow = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const ContentWrapper = styled.div<{ gap?: string; mb?: string; mt?: string }>`
  ${({ gap = '4px', mb = undefined, mt = undefined }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${gap};
    margin-bottom: ${mb};
    margin-top: ${mt};
  `}
`

export const InsuranceBottomSheetList = styled.div`
  display: grid;
  grid-template-columns: 60% 30%;
  justify-content: space-between;
  padding-bottom: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--gray200);
  }
`

export const InsuranceBottomSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const TermsPageContainer = styled(Page)`
  padding: 0 24px;
`

export const PDFContainer = styled.div`
  margin: 0 -12px;

  canvas {
    width: 100% !important;
    height: auto !important;
  }
`

export const PDFController = styled.div`
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  margin: 0 -24px;
  padding: 16px 24px 24px;
  border-top: 1px solid var(--gray200);
  background-color: var(--white500);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const PDFControllerButton = styled.button`
  border: 0;
  background: none;
  color: var(--primary500);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;

  &:disabled {
    color: var(--gray300);
    cursor: not-allowed;
  }
`
